export const CONNECT = "connect";
export const ON_CONNECTION = "on_connection";
export const CONNECT_ERROR = "connect_error";
export const CONNECT_TIMEOUT = "connect_timeout";
export const DISCONNECT = "disconnect";
